import { useIntl } from 'react-intl';
export default function useFormattedPlaceholder(placeholder) {
  const {
    formatMessage
  } = useIntl();

  if (!placeholder || typeof placeholder === 'string') {
    return placeholder;
  }

  return formatMessage(placeholder);
}